import { faRocket } from '@fortawesome/pro-regular-svg-icons';
import { Flex } from 'portal-commons';

import RcsSectionBlock from './RcsSectionBlock';
import InfoItem from './InfoItem';
import InfoItemLayout from './InfoItemLayout';
import { RcsCampaign } from '../../types';

interface LaunchDetailsSectionProps {
  onEdit: () => void;
  editable?: boolean;
  campaign?: RcsCampaign;
}

const LaunchDetailsSection = ({
  onEdit,
  editable,
  campaign,
}: LaunchDetailsSectionProps) => {
  return (
    <RcsSectionBlock
      icon={faRocket}
      title="Launch Details"
      showDivider={true}
      editable={editable}
      onEditClick={onEdit}
    >
      <Flex
        sx={{
          flexDirection: 'column',
          gap: 's',
        }}
      >
        <InfoItemLayout.Horizontal>
          <InfoItem title="Action Trigger Messages">
            {campaign?.actionTriggerMessages}
          </InfoItem>
          <InfoItem title="Types of Messages Sent">
            {campaign?.messageTypes}
          </InfoItem>
        </InfoItemLayout.Horizontal>
        <InfoItemLayout.Horizontal>
          <InfoItem title="Opt-In">{campaign?.optinFlow}</InfoItem>
          <InfoItem title="Opt-Out">{campaign?.optoutFlow}</InfoItem>
        </InfoItemLayout.Horizontal>
        <InfoItemLayout.Horizontal>
          <InfoItem title="Screenshot URL">{campaign?.screenshotUrl}</InfoItem>
          <InfoItem title="Video URL">{campaign?.videoUrl}</InfoItem>
        </InfoItemLayout.Horizontal>
      </Flex>
    </RcsSectionBlock>
  );
};

export default LaunchDetailsSection;
